/**
 * Standard `border-radius` sizes.
 *
 * @see https://www.figma.com/design/fXJgb6WJoQ6L1hpdCVpEh6/Colors?node-id=127-110&m=dev&vars=1&var-id=211-679
 */
export const enum CornerRadius {
  XSmall = 2,
  Small = 4,
  Medium = 6,
  Large = 8,
  XLarge = 12,
}
